import ProgressBar from "@ramonak/react-progress-bar";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

import excelIcon from "../../assets/icons/excel2-svgrepo-com.svg";
import pdfIcon from "../../assets/icons/pdf-file-svgrepo-com.svg";
import wordIcon from "../../assets/icons/word2-svgrepo-com.svg";
import closeicon from "../../assets/images/closeicon.svg";
import emptyImage from "../../assets/images/emptyAvatar.svg";
import upload from "../../assets/images/uploadIcon.svg";
import useFileUpload from "../../hooks/useFileUpload";
import { getImage } from "../../utils/utils";
import ImageContainer from "../shared/ImageContainer";
import Loader from "../shared/Loader";

const TicketUploader = ({
  fieldChange,
  mediaUrl = [],
  disabled,
  acceptedFormats,
  emptyAvatar,
  pic_type,
  text,
  label,
}) => {
  const [file, setFile] = useState([]);
  const [fileIsUploading, setFileIsUploading] = useState(false);

  const { progress, uploading, error, uploadFile } = useFileUpload();

  const handleUpload = async ({ files, pic_type }) => {
    setFileIsUploading(true);
    let fuleUrls = [];
    try {
      const uploadPromises = files.map(async (file) => {
        try {
          const res = await uploadFile({ file, pic_type });

          if (res?.status === 200) {
            const { url, preview_url } = res.data;
            fuleUrls.push({ url, preview_url });

            return res;
          } else {
            console.error("Upload failed for file:", file.name);
            fuleUrls.push("url");
          }
        } catch (err) {
          console.error("Error uploading file:", file.name, err);
          fieldChange("");
          throw err;
        }
      });

      await Promise.all(uploadPromises);
    } catch (err) {
      console.error("Error during file upload process:", err);
    } finally {
      setFileIsUploading(false);
      fieldChange(fuleUrls);
    }
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      handleUpload({ files: acceptedFiles, pic_type: pic_type });
    },
    [file],
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": acceptedFormats,
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx", ".xls", ".csv"],
      "application/msword": [".doc", ".docx"],
    },
    disabled,
  });

  const renderAttachmentPreview = (file) => {
    if (!file) return null;

    let icon = null;

    if (file.includes("xlsx")) icon = excelIcon;
    if (file.includes("docs")) icon = wordIcon;
    if (file.includes("pdf")) icon = pdfIcon;

    return (
      <div className="attachment-preview w-full  rounded-t-lg flex justify-between items-center ">
        {false ? (
          <Loader />
        ) : (
          <div className="attachment-info flex items-center gap-2 w-full ">
            {icon ? (
              <>
                <img src={icon} alt="file icon" className="w-10 h-10 " />
                <span className="truncate text-end max-w-[300px]">{file}</span>
              </>
            ) : (
              <ImageContainer src={getImage(file)} width="64px" height="64px" />
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      {...getRootProps()}
      className="flex flex-col flex-center   bg-dark-3 rounded-xl cursor pointer gap-2 text-[12px] md:text-[16px]  "
    >
      <label className=" ml-auto" htmlFor="">
        {label}
      </label>
      <input {...getInputProps()} className="cursor-pointer" />

      {fileIsUploading ? (
        <>
          <Loader /> در حال ذخیره سازی ...
        </>
      ) : (
        <>
          <div
            className={
              disabled
                ? "hidden"
                : "userStatus border-dashed border-2 border-black rounded-xl cursor pointer gap-2 w-full flex flex-col items-center p-2"
            }
          >
            <img className="cursor-pointer" src={upload} alt="uploadIcon" />

            <div className="flex flex-col items-center gap-1 w-full ">
              {text ? (
                text
              ) : (
                <>
                  <p>تصویر مدرک را درون کادر کشیده</p>
                  <p>و یا از میان پوشه‌هایتان انتخاب کنید </p>
                </>
              )}
              <p dir="ltr" className="text-neutral-70 small-regular mb-1">
                {acceptedFormats.map((item, index) => (
                  <span key={index} className="mx-[0.25px]">
                    {item}
                  </span>
                ))}
              </p>
            </div>
          </div>
        </>
      )}

      {mediaUrl.length > 0 ? (
        <div className="bg-neutral-30 flex-between  gap-4 w-full p-2  rounded-xl">
          {uploading ? (
            <ProgressBar completed={progress} maxCompleted={100} className="w-full" bgColor="#39A78E" />
          ) : (
            <>
              <div className="flex items-center gap-4">
                {mediaUrl.map((item) => {
                  return renderAttachmentPreview(item.preview_url);
                })}
              </div>
              {!disabled && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    fieldChange("");
                  }}
                >
                  <img className="w-7 h-7  ml-[6px]" src={closeicon} alt="closeicon-arrow" />
                </button>
              )}
            </>
          )}
        </div>
      ) : (
        <>
          {emptyAvatar ? (
            <div className="bg-neutral-30 flex-between  gap-4 w-full p-2  rounded-xl">
              <img
                src={emptyImage}
                alt="emptyAvatar"
                className="size-1 h-[150px] rounded-lg min-w-[150px] min-h-[150px]"
              />
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      {error && <div style={{ color: "red" }}>خطا:{error.message} </div>}
    </div>
  );
};

export default TicketUploader;
